'use client';

import { History } from '@repo/types';
import { MessageSquare } from 'lucide-react';

interface TravauxCommentairesProps {
  history: History;
}

export function TravauxCommentaires({ history }: TravauxCommentairesProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-semibold text-gray-900 flex items-center gap-2">
        <MessageSquare className="h-4 w-4 text-primary" />
        Commentaires travaux
      </label>
      <div className="bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 min-h-[2.5rem] transition-all duration-200 hover:border-gray-300 hover:bg-gray-100/50">
        <p className="text-sm text-gray-900 leading-relaxed whitespace-pre-wrap">
          {history.travaux_commentaire}
        </p>
      </div>
    </div>
  );
}
